import { ReactElement } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import MainContainer from "./components/containers/MainContainer";
import StateBasedRedirect from "./components/containers/StateBasedRedirect";
import GlobalStyle from "./GlobalStyle";
import BusinessUnitsPage from "./pages/business-units/BusinessUnitsPage";
import LoginPage from "./pages/logged-out/LoginPage";
import TaskHistoryPage from "./pages/task-history/TaskHistoryPage";
import Providers from "./providers/Providers";

export default function App(): ReactElement {
  return (
    <Providers>
      <GlobalStyle />
      <BrowserRouter>
        <Routes>
          <Route path={routes.root} element={<StateBasedRedirect />} />
          <Route path={routes.loggedOut} element={<LoginPage />} />
          <Route path={routes.home} element={<MainContainer />} />
          <Route path={routes.businessUnitsLogin} element={<BusinessUnitsPage justLoggedIn={true} />} />
          <Route path={routes.businessUnits} element={<BusinessUnitsPage justLoggedIn={false} />} />
          <Route path={routes.taskHistory} element={<TaskHistoryPage />} />
        </Routes>
      </BrowserRouter>
    </Providers>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const routes = {
  root: "/",
  loggedOut: "/logged-out",
  home: "/home",
  businessUnitsLogin: "/business-units-login",
  businessUnits: "/business-units",
  taskHistory: "/task-history",
};
